// extracted by mini-css-extract-plugin
module.exports = {"settingsForm":"drawer_settingsForm__1mxnh","dropdownLanguages":"drawer_dropdownLanguages__yHYCa"};